import {get, put} from './http';

// The fixed eight-colour flag palette, mirroring FlagColors server-side. Order is display order.
// Flags live on items only (see ItemFlag server-side); a submission shows its item's flag.
export const FLAG_COLORS = [
  'red',
  'orange',
  'yellow',
  'green',
  'teal',
  'blue',
  'purple',
  'pink'
] as const;

export type FlagColor = (typeof FLAG_COLORS)[number];

// One of the caller's flags as GET /me/flags returns it. `name` is what to show: their own `label`
// when they gave the colour one, else `default_name`.
export type Flag = {
  color: FlagColor;
  default_name: string;
  label: string | null;
  name: string;
};

// ItemFlagsController limits: SetFlagNoteRequest.MaxLength and RenameFlagRequest.MaxLength.
export const FLAG_NOTE_MAX_LENGTH = 1000;
export const FLAG_LABEL_MAX_LENGTH = 40;

export const flagsApi = {
  list: async () => get<Flag[]>('/me/flags'),
  // Names one flag, or clears its name when blank. Touches only that colour.
  rename: async (color: FlagColor, label: string | null) =>
    put<{label: string | null}>(`/me/flags/${color}`, {label})
};
